import React from 'react';
import { RiLoginCircleFill } from "react-icons/ri";

const UserSection = ({ 
  isAuthenticated, 
  user, 
  showUserMenu, 
  setShowUserMenu, 
  setShowLoginModal, 
  handleLogout 
}) => {
  return (
    <div className="user-section">
      {isAuthenticated && user ? (
        <div className="user-menu">
          <div className="user-avatar" onClick={() => setShowUserMenu(!showUserMenu)}>
            {user.photoURL ? (
              <img src={user.photoURL} alt="Profile" className="user-profile-image" />
            ) : (
              <i className="fas fa-user-circle"></i>
            )}
          </div>
          
          {showUserMenu && (
            <div className="user-dropdown">
              <div className="user-info">
                <span className="user-name">{user.name}</span>
                <span className="user-email">{user.email}</span>
              </div>
              <button onClick={handleLogout} className="dropdown-logout-btn">
                <i className="fas fa-sign-out-alt"></i> Sign Out
              </button>
            </div>
          )}
        </div>
      ) : null}
    </div>
  );
};

export default UserSection;
